import axios from 'axios'
import security from '@/services/security.js'

export default {
  get (courseKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/faqs/' + courseKey, config)
      .then(response => {
        return response.data
      })
  },
  update (courseKey, faq) {
    const config = { headers: security.getAuthHeader() }
    return axios.put('/faqs/' + courseKey, faq, config)
      .then(response => {
        return response.data
      })
  },
  add (courseKey, faq) {
    const config = { headers: security.getAuthHeader() }
    return axios.post('/faqs/' + courseKey, faq, config)
      .then(response => {
        return response.data
      })
  },
  delete (courseKey, id) {
    const config = { headers: security.getAuthHeader() }
    return axios.delete('/faqs/' + courseKey + '/' + id, config)
      .then(response => {
        return response.data
      })
  }
}
